<form [formGroup]="formGroup">
  <div class="wrapping-group">
    <mat-form-field>
      <mat-label>{{ 'name' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="name" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'jobPosition' | i18nextCap }}</mat-label>
      <input matInput type="text" formControlName="jobPosition" />
    </mat-form-field>
  </div>
  <mat-form-field>
    <mat-label>{{ 'address' | i18nextCap }}</mat-label>
    <input matInput type="text" formControlName="address" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'email' | i18nextCap }}</mat-label>
    <input matInput type="text" formControlName="email" />
  </mat-form-field>
  <mat-form-field>
    <mat-label>{{ 'phone' | i18nextCap }}</mat-label>
    <input matInput type="text" formControlName="mobileNumber" />
  </mat-form-field>
  <div class="field-with-buttons">
    <mat-form-field>
      <mat-label>{{ 'company' | i18nextCap }}</mat-label>
      <fo-autocompleting-select
        [choices]="companies$"
        formControlName="company"
      />
      <fo-arrow matSuffix />
    </mat-form-field>
    @if (!companyDisabled) {
      <button
        mat-icon-button
        color="primary"
        [disabled]="formGroup.controls.company.value == null"
        [routerLink]="[
          '/',
          'companies',
          formGroup.controls.company.value?.id,
          'edit',
        ]"
      >
        <mat-icon>account_balance</mat-icon>
      </button>
    }
  </div>
  <mat-form-field>
    <mat-label>{{ 'notes' | i18nextCap }}</mat-label>
    <textarea matInput formControlName="notes"></textarea>
  </mat-form-field>
  <button
    mat-flat-button
    color="primary"
    type="button"
    [disabled]="formGroup.invalid || disabled"
    (click)="onClickSave()"
  >
    {{ 'save' | i18nextCap }}
  </button>
</form>
